export const contentTypes = {
  COMPATIBILITY: "compatibility",
  NEW_FEATURE: "new_features",
  AMELIORATION: "amelioration",
  CORRECTION: "correction",
};
